import React, { useContext, useEffect, useState } from 'react'
import LoadMoreButton from '../../../../components/Accesses/LoadMoreButton'
import axios from 'axios'
import pen from '../../../../assets/productions/pen.svg'
import { ConfigButton, GlobalTable, HeaderLine, Td, TdButtons, Th, Tr } from '../../../../components/table-style'
import { FieldsManagerType } from '../../../../components/FieldManager'
import { Settings, Settings2 } from 'lucide-react'

interface CompanyInterface{
  id:number
  companyTypes:string[]
  cnpj: string
  companyName: string
  stateRegistration: string
  address: string
  phone: string
  email: string
  contactName: string
}

interface TableCompanyType {
  whichFieldsToShow: FieldsManagerType
  dropdownOpen: React.Dispatch<React.SetStateAction<boolean>>
} 

const TableCompanies:React.FC<TableCompanyType> = ({whichFieldsToShow, dropdownOpen}) => {
  const [ companies, setCompanies ] = useState<CompanyInterface[]>([])
  
  const handleEdit = () => {
    
  }

  useEffect(() => {
    const params = {
      filters: [1,2]
    }
    axios.get(`${process.env.REACT_APP_COMPANIES_BASE_URL}/companies`, { params })
    .then(response => {
      if(response.data)
        setCompanies(response.data)
      return
    })
    .catch(error => {
      setCompanies([])
      console.error(error)
    })
  }, [])
    
  return (
    <>
      <GlobalTable>
        <tbody>
          <HeaderLine>
            {whichFieldsToShow.whichFieldsToShow.filter(field => field.checked).map((field,index) => (
              <Th key={index}>{field.fieldName}</Th>
            ))}
            <ConfigButton onClick={() => dropdownOpen(prev => !prev)}><Settings/></ConfigButton>
          </HeaderLine>
          {companies.map((company:any|CompanyInterface) => 
            <Tr key={company.id}>
              {whichFieldsToShow.whichFieldsToShow.filter(field => field.checked).map((field, index) => 
                <Td key={index}>
                  {field.fieldName !== 'companyTypes' ? company[field.field] : company.companyTypes.join(', ')}
                </Td>
              )}
              <TdButtons className='edit'><img src={pen} alt='pen icon'/></TdButtons>
            </Tr>
          )}
        </tbody>
      </GlobalTable>
      <LoadMoreButton />
    </>
  )
}

export default TableCompanies